import xs from "xstream"
import { div, label, button, select, hr, input, span } from "@cycle/dom"
import * as R from "ramda"

import {
  WorkForm,
} from "../../../../interface"
import {
  INPUT_INFO,
  MODIFY_MSG,
} from "../../../../constant"

import {
  createTextArea,
  createTextInput,
  createCheckbox,
} from "../../../common"
import { createPrefSelect, prefOptions } from ".."

export const createZipInputs =(zip1Key: string, zip2Key: string, prefKey: string, addrKey: string) => (
  userForm: any,
  errorCheck: any,
  zipMsg: string | null,
  readOnly = false
) => {
  const zip1 = R.propOr("", zip1Key, userForm)
  const zip2 = R.propOr("", zip2Key, userForm)
  const zipErr1 = R.pathOr(false, [zip1Key, "check"], errorCheck)
  const zipErr2 = R.pathOr(false, [zip2Key, "check"], errorCheck)
  const errMsg =
    !(zipErr1 && zipErr2 ) ? R.path(["zip1", "message"], errorCheck) : null
  const zip1Class = readOnly
    ? "form-control-plaintext"
    : zipErr1 ? "" : "is-invalid"
  const zip2Class = readOnly
    ? "form-control-plaintext"
    : zipErr2 ? "" : "is-invalid"
  return div(".mt-0", [
    div(".d-flex.align-items-center.col-md-6.mt-0", [
      span(["〒"]),
      input(`.form-control.${zip1Class}`, {
        attrs: {
          type: "text",
          name: zip1Key,
          minLength: 3,
          maxLength: 3,
          inputmode: "numeric",
          readOnly,
        },
        props: { value: zip1 },
      }),
      span(["-"]),
      input(`.form-control.${zip2Class}`, {
        attrs: {
          type: "text",
          name: zip2Key,
          minLength: 4,
          maxLength: 4,
          inputmode: "numeric",
          readOnly,
        },
        props: { value: zip2 },
      }),
      button(
        "#btnAddr.btn.btn-primary.btn-sm.ms-2.flex-shrink-0",
        { attrs: {
            type: "button",
            "data-key1": zip1Key,
            "data-key2": zip2Key,
            "data-pref": prefKey,
            "data-addr": addrKey,
            disabled: !(zipErr1 && zipErr2)
          }
        },
        ["検索"],
      ),
    ]),
    errMsg
      ? div(".invalid-feedback.d-block", [errMsg])
      : zipMsg
      ? div(".invalid-feedback.d-block", [zipMsg])
      : null,
  ])
}


export const drawAddrSelect = (userForm: WorkForm , errorCheck: any, readOnly: boolean) => {
  const check = R.path(["addrSelect", "check"], errorCheck)
  const errMsg = check || readOnly ? null  : R.path(["addrSelect", "message"], errorCheck)
  const valid = check || readOnly ? "" : ".is-invalid"
  return div([
    div(".form-check.form-check-inline", [
      label(".pure-radio", { attrs: { for: "r1" } }, [
        input(`#r1.form-check-input${valid}`, {
          attrs: { type: "radio", name: "addrSelect", value: "勤務先", disabled: readOnly },
          props: { checked: R.prop("addrSelect", userForm) === "勤務先" },
        }),
        "勤務先"
      ]),
    ]),
    div(".form-check.form-check-inline", [
      label(".pure-radio", { attrs: { for: "r2" } }, [
        input(`#r2.form-check-input${valid}`, {
          attrs: { type: "radio", name: "addrSelect", value: "ご自宅", disabled: readOnly },
          props: { checked: R.prop("addrSelect", userForm) === "ご自宅" },
        }),
        "ご自宅"
      ]),
    ]),
    errMsg
      ? div(".invalid-feedback.d-block", [errMsg])
      : null
  ])
}

export const view = (
  userForm$: xs<WorkForm>,
  errorCheck$: xs<any>,
  zipMsg$: xs<string | null>,
  readOnly = false,
) =>
  xs
    .combine(userForm$, errorCheck$, zipMsg$)
    .map(
      ([userForm, errorCheck, zipMsg]: [
        WorkForm,
        any,
        string | null,
      ]) => {
        const disabled = R.find(
          (arr) => arr[1].check === false,
          R.toPairs(errorCheck),
        )
          ? true
          : false
        const gutter = readOnly ? "" : ".mt-2"
        return div([
          div(".form.mt-1", [
            div(`.row${gutter}`, [
              div(".col-md-6", [ '【勤務先情報】'])
            ]),
            readOnly ? null : div(".fw-bold.mt-0.mb-2", ["勤務先に変更がある場合はこの欄をご入力下さい"]),
            div(`.row${gutter}`, [
              createTextInput("workPlace", readOnly)(userForm, errorCheck),
            ]),
            div(`.row${gutter}`, [
              createTextInput("workSection", readOnly)(userForm, errorCheck),
            ]),
            div(`.row${gutter}`, [
              createTextInput("occupation", readOnly)(userForm, errorCheck),
            ]),
            div(`.row${gutter}`, [
              label(".form-label", ["郵便番号"]),
              createZipInputs("wZip1", "wZip2", "wPref", "wAddr")(userForm, errorCheck, zipMsg, readOnly),
            ]),
            div(`.row${gutter}`, [
              div(".col-md-3", [
                label(".form-label", ["都道府県"]),
                createPrefSelect("wPref")(userForm, errorCheck, readOnly),
              ]),
            ]),
            div(`.row${gutter}`, [createTextInput("wAddr", readOnly)(userForm, errorCheck)]),
            // div(`.row${gutter}`, [createTextInput("addr2", readOnly)(userForm, errorCheck)]),
            div(`.row${gutter}.mt-1`, [
              createTextInput("wTel", readOnly)(userForm, errorCheck),
            ]),
            div(`.row${gutter}`, [createTextInput("wFax", readOnly)(userForm, errorCheck)]),
            hr(),
            div(`.row${gutter}`, [
              div(".col-md-6", [ '【ご自宅住所】'])
            ]),
            readOnly ? null : div(".fw-bold.mt-0.mb-2", ["ご自宅住所に変更がある場合はこの欄をご入力下さい"]),
            div(`.row${gutter}`, [
              label(".form-label", ["郵便番号"]),
              createZipInputs("zip1", "zip2", "pref", "addr1")(userForm, errorCheck, zipMsg, readOnly),
            ]),
            div(`.row${gutter}`, [
              div(".col-md-3", [
                label(".form-label", ["都道府県"]),
                createPrefSelect("pref")(userForm, errorCheck, readOnly),
              ]),
            ]),
            div(`.row${gutter}`, [createTextInput("addr1", readOnly)(userForm, errorCheck)]),
            div(`.row${gutter}`, [createTextInput("addr2", readOnly)(userForm, errorCheck)]),
            div(`.row${gutter}.mt-1`, [
              createTextInput("tel", readOnly)(userForm, errorCheck),
            ]),
            div(`.row${gutter}`, [createTextInput("fax", readOnly)(userForm, errorCheck)]),
            div(`.row${gutter}`, [createTextInput("mobile", readOnly)(userForm, errorCheck)]),
            hr(),
            div(`.row${gutter}`, [
              div(".col-md-6", ["【ご連絡先選択】"]),
            ]),
            readOnly ? null : div(".fw-bold.mt-0.mb-2", ["郵便物等の送付先住所を選択してください。"]),
            div(`.row${gutter}`, [
              drawAddrSelect(userForm, errorCheck, readOnly),
            ]),
            hr(),
            div(`.row${gutter}`, [createTextArea("bikou", readOnly)(userForm, errorCheck)]),
            div(".d-grid.gap-3.mt-4", [
              div(".col.col-md-4", [
                readOnly
                  ? button(
                    "#btnSend.btn.btn-danger.w-100",
                    { props: { disabled: disabled } },
                    ["変更申請を行う"],
                  )
                  : button(
                    "#btnConfirm.btn.btn-primary.w-100",
                    { props: { disabled: disabled } },
                    ["申請内容を確認する"],
                  ),
              ]),
              div(".col.col-md-4", [
                button( "#btnReturn.btn.btn-success.w-100", ["戻る"]),
              ]),
            ]),
          ]),
        ])
      },
    )
